import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

export const LeadAssignedCard = ({ items }) => {
  //  console.log(items,"items")
  return (
    <div className="m-2 ">
      <Card className="assignedcard">
        <CardActionArea
          sx={{
            //   height: '100%',
            '&[data-active]': {
              backgroundColor: 'action.selected',
              '&:hover': {
                backgroundColor: 'action.selectedHover',
              },
            },
          }}
        >
          <CardContent sx={{ height: '100%' }}>
            <Typography variant="h5" component="div">
              Lead Name :{items ? (items.LeadId ? items?.LeadId?.name : null) : null}
            </Typography>
            <Typography variant="body2" color="text.secondary" className="d-flex flex-wrap">
              <div className="w-100">Date Assigned :{items?.date_Assigned}</div>
              <div className="w-100 my-2">
                {' '}
                Assigned From (User):
                {items ? (items.Assigned_From ? items.Assigned_From.name : null) : null}
              </div>
              <div className="w-100">
                Assigned To (sales) :{' '}
                {items ? (items.Assigned_to ? items.Assigned_to.name : null) : null}
              </div>
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
};
